import { isCotaOrExtra } from "./data";
import { parseBetsDataMacrogruppo } from "./parseBetsDataMacrogruppo";
import { parseMacroGruppi } from "./parseMacroGruppi";
import { getLiveAggs, getPrematchAggs } from "./utils";

export function parseMatchDataMacrogruppo(data, idMacrogruppo, match, isLive) {
    // Creo un array con tutte i dati di tutte le aggregate, filtrando le aggregate "tutte"
    const aggMap = isLive ? getLiveAggs(match.sportRef) : getPrematchAggs(match.sportRef);
    const gruppoById = {};
    let aggs = data.ags;
    if (!window.isCotaExtraEnabled) {
        aggs = aggs.filter(aggId => aggId > 0 && !isCotaOrExtra(isLive, match.sportRef, aggId));
    }
    aggs.forEach(ag => {
        if (aggMap[ag] != null) {
            gruppoById[ag] = aggMap[ag];
        }
    });
    const macrogruppi = parseMacroGruppi(gruppoById, match.sportRef, false);
    macrogruppi.sort((a, b) => {
        if (a.id < 0) {
            return -1;
        } else if (b.id < 0) {
            return 1;
        } else if (a.isPrincipale) {
            return -1;
        } else if (b.isPrincipale) {
            return 1;
        }
        return a.ranking - b.ranking;
    });
    const mg = macrogruppi.find(mg => mg.id === idMacrogruppo);

    match.widgetType = data.wty;
    match.geniusId = data.gid;
    match.lsportWidgetId = data.lswid;

    const matchData = {
        alias: match.alias,
        avv: match.avv,
        desc: match.desc,
        geniusId: match.geniusId,
        id: match.id,
        lsportWidgetId: match.lsportWidgetId,
        pal: match.pal,
        sportDesc: match.sportDesc,
        sportRef: match.sportRef,
        timestamp : match.timestampDB,
        tournamentDesc: match.tournamentDesc,
        tournamentRef : match.tournamentRef,
        uniqueId: match.uniqueId,
        urlPath: match.urlPath,
        urlPathSeo: match.urlPathSeo,
        urlPathSeoSettings: match.urlPathSeoSettings,
        widgetType: match.widgetType
    };

	const scommesse = parseBetsDataMacrogruppo(matchData, aggs, mg, data.scs, isLive);
    // if (match.avvRef != null) {
    //     addMatchBets(scommesse, match);
    // }

	return {
        bets: scommesse,
        scommesse,
        gruppoById,
        macrogruppi
    };
}
